import Form from "../../form";

import { ask } from '../../../utils/popups';
import { handle } from '../../../service/messages';
import { error } from '../../../ui/messages';

import i18n from '../../../i18n';

let ifn; i18n.then( i => ifn = i );





export const FieldForm = Form.extend( {

    template: 'module/refbooks/fields.form.subfield',

    onBind(model) {
        this.listenTo( model, 'change',
            () => this.$el.closest( '.modal' )
                .find( '.action-accept' )[0].disabled = !this.hasDiff() );

        // see fields.form.bound-stickers.js
        // cannot change cluster in nested model

        // see fields.form.bound-stickers.js
        this.listenTo( model, 'change:format', () => {
            if (model.get( 'format' ) !== 'file' )
                this.stickersPage = 1, this.stickersSort = 'name', this.stickersDirection = 'asc', this.stickersSearch = '';
        } );
    },

    // see fields.form.bound-stickers.js
    serialize() {
        const { 
            stickersSort, stickersDirection, stickersSearch, stickersPage,
        } = this;

        return {
            stickersSort, stickersDirection, stickersSearch, stickersPage,
        };
    },

    [Form.event( 'Fields:file-semantics:toggle' )](passedSemantics) {
        const contains = this.model.get( 'file_semantics' ).includes( passedSemantics );
        const newSemantics = contains
            ? this.model.get( 'file_semantics' ).filter( ft => ft !== passedSemantics )
            : [...this.model.get( 'file_semantics' ), passedSemantics];
        this.model.set( 'file_semantics', newSemantics );
    },

    // see fields.form.bound-stickers.js
    [Form.event( 'Stickers:page')](page) {
        return this.stickersPage = +page;
    },

    // see fields.form.bound-stickers.js
    [Form.event( 'Stickers:sort')]({ sort, direction }) {
        return this.stickersSort = sort, this.stickersDirection = direction;
    },

    // see fields.form.bound-stickers.js
    [Form.event( 'Stickers:search')](search) {
        return this.stickersSearch = search, this.stickersPage = 1;
    },

    [Form.event(':tab:toggle')](tab) {
        return this.options.tab = tab, this.render();
    },

}, {

    popup(subfieldModel, { popupLabel, applyLabel, warning, level = 0 }, { datatables, types, stickers, roles }) {
        const binding = new FieldForm( { 
            datatables, types, stickers, roles,

            level,
            tab: 'main',
            stickersPage: 1, stickersSort: 'name', stickersDirection: 'asc', stickersSearch: '',
        } ).bind( subfieldModel );
    
        return ask( binding, popupLabel, applyLabel, 'actions::cancel', 
            { 
                warning,
                medium: true,
                afterRender(ctx, firstTime) {
                    if (firstTime)
                        this.$( '.action-accept' )[0].disabled = true;
                }
            }, 
            () => {
                if (!subfieldModel.get( 'name' ).trim())
                    return handle( binding.view, error( [ifn( 'forms::required field' ), 'name'] ) ), 
                        false;
            } )
            .then( () => subfieldModel );
    }

} )


// WEBPACK FOOTER //
// ./src/js/view/module/refbooks/fields.form.popup.js